import { useCallback, useState } from "react";

export const useLocation = () => {
  const [locationDenied, setLocationDenied] = useState(false);

  const fetchLocation = useCallback(async () => {
    if (!navigator.geolocation) {
      setLocationDenied(true);
      return null;
    }

    // Check permission state first
    try {
      if (navigator.permissions) {
        const permissionStatus = await navigator.permissions.query({
          name: "geolocation",
        });
        if (permissionStatus.state === "denied") {
          setLocationDenied(true);
          return null;
        }
      }
    } catch {
      // Permissions API not available — fall through
    }

    // Now request position
    return new Promise<Record<string, number | null> | null>((resolve) => {
      navigator.geolocation.getCurrentPosition(
        (info) => {
          if (info?.coords) {
            const location = {
              accuracy: info.coords.accuracy,
              altitude: info.coords.altitude,
              altitudeAccuracy: info.coords.altitudeAccuracy,
              latitude: info.coords.latitude,
              longitude: info.coords.longitude,
            };
            localStorage.setItem("userLocation", JSON.stringify(location));
            setLocationDenied(false);
            resolve(location);
          } else {
            resolve(null);
          }
        },
        (error) => {
          if (error.code === error.PERMISSION_DENIED) {
            setLocationDenied(true);
          }
          resolve(null);
        },
        { enableHighAccuracy: true, timeout: 20000, maximumAge: 1000 }
      );
    });
  }, []);

  const getLocation = useCallback(() => {
    const stored = localStorage.getItem("userLocation");
    return stored ? JSON.parse(stored) : null;
  }, []);

  return { fetchLocation, getLocation, locationDenied };
};
